import { Editor, Element } from "slate";
const topLevelNodes = (editor) => {
  return Editor.nodes(editor, {
    match: (node) => Element.isElement(node) && !editor.isVoid(node),
    mode: "highest",
    voids: false
  });
};
export {
  topLevelNodes
};
//# sourceMappingURL=topLevelNodes.js.map
